"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = void 0;
var _comments = _interopRequireDefault(require("@tine/tiff/dist/templates/comments"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Component = exports.Component = _comments.default;
var _default = exports.default = {
  Component: Component
};